import { mixin as clickaway } from 'vue-clickaway'
import Vue from 'vue'

Vue.mixin({
    mixins: [clickaway]
})
